"use client";

import { SelectedValue } from "@/interface/dataInterface";
import { expenseAndService } from "@/utils/objects";
import axios from "axios";
import { FC, useEffect, useState } from "react";
import CommonEdit from "@/components/common/Edit";
import { BASE_URL } from "@/config";
import { mergeDateAndTime, seperateDateAndTime } from "@/utils/formChange";
import ServiceForm from "../forms/ServiceForm";

interface Props {
    id: number;
  title: string;
  description?: string;
}

const ServiceEdit: FC<Props> = ({ id, title, description }) => {
  const [formProp, setFormProp] = useState(expenseAndService);
  const [otherData, setOtherData] = useState<SelectedValue[]>([]);

  useEffect(() => {
    if (id) {
        axios.get(`${BASE_URL}/service/${id}`, {
            headers: {
              Authorization: `Bearer ${window.localStorage.getItem("access_token")}`,
          },
        })
        .then(res => {
          const {odometer, notes, date, vehicle_id, service_type_values} = res.data;
            setFormProp({
              odometer: odometer || 0,
              notes: notes || "",
              time: seperateDateAndTime(date).timePart || "",
              vehicle_id: vehicle_id || 0,
              date: seperateDateAndTime(date).datePart || date,
            });
            setOtherData(service_type_values.map((item: any) => ({
              id: item.service_type.id,
              name: item.service_type.name,
              value: item.value,
            })));
        })
        .catch(err => console.log(err))
    }
  }, [id])

  return (
    <CommonEdit
      id={id}
      title="Edit"
      resource="service"
      data={{...formProp, date: mergeDateAndTime(formProp.date, formProp.time), vehicle_id: +formProp.vehicle_id, service_type_list: otherData}}>
        <ServiceForm formProp={formProp} setFormProp={setFormProp} otherData={otherData} setOtherData={setOtherData}/>
      </CommonEdit>
  );
};

export default ServiceEdit;
